import React, { FormEvent, useState } from 'react';
import {
  Container,
  Button,
  Field,
  Control,
  Input,
  Columns,
  Column,
  Notification,
  Delete,
  Icon
} from 'bloomer';
import { firebaseApp } from '../firebase/firebase';
import logo from '../img/logo.png';

export function SignInForm() {
  const [errorMessage, setErrorMessage] = useState('');
  const [credentials, setCredentials] = useState({ email: '', password: '' } as Credentials);

  return (
    <form onSubmit={e => submitLoginForm(e, credentials, setErrorMessage)}>
      <Container style={{ marginBottom: '30px' }}>
        <Columns isCentered isVCentered>
          <Column isSize="1/3"></Column>
          <Column isSize="1/3" hasTextAlign="centered">
            <div style={{ marginTop: '40px', marginBottom: '20px' }}>
              <img style={{ width: '350px' }} src={logo} alt="logo" />
            </div>
            {errorMessage && (
              <Notification isColor="danger">
                <Delete onClick={() => setErrorMessage('')} />
                {errorMessage}
              </Notification>
            )}
            <Field>
              <Control hasIcons="left">
                <Icon className="fas fa-envelope"></Icon>
                <Input
                  value={credentials.email}
                  onChange={(event: React.FormEvent<HTMLInputElement>) =>
                    setCredentials({ ...credentials, email: event.currentTarget.value })
                  }
                  type="email"
                  name="email"
                  placeholder="Email"
                  autoComplete="username"
                  autoFocus
                />
              </Control>
            </Field>
            <Field>
              <Control hasIcons="left">
                <Icon className="fas fa-lock"></Icon>
                <Input
                  value={credentials.password}
                  onChange={(event: React.FormEvent<HTMLInputElement>) =>
                    setCredentials({ ...credentials, password: event.currentTarget.value })
                  }
                  type="password"
                  name="password"
                  placeholder="Password"
                  autoComplete="current-password"
                />
              </Control>
            </Field>
            <Field>
              <Button isColor="primary" isFullWidth type="submit">
                Sign in
              </Button>
            </Field>
            <Field>
              <Columns>
                <Column>
                  <Control>
                    <Button isFullWidth onClick={() => signUp(credentials, setErrorMessage)}>
                      Sign up
                    </Button>
                  </Control>
                </Column>
                <Column>
                  <Control>
                    <Button isFullWidth onClick={() => forgotPassword(credentials, setErrorMessage)}>
                      Forgot Password
                    </Button>
                  </Control>
                </Column>
              </Columns>
            </Field>
            <div>
              <small>
                <a href="/privacy_policy" target="_blank" style={{ color: '#333' }}>
                  Privacy Policy
                </a>
              </small>
              <span style={{ color: '#333' }}> | </span>
              <small>
                <a href="/terms_and_conditions" target="_blank" style={{ color: '#333' }}>
                  Terms &amp; Conditions
                </a>
              </small>
            </div>
          </Column>
          <Column isSize="1/3"></Column>
        </Columns>
      </Container>
    </form>
  );
}

async function submitLoginForm(
  event: FormEvent<HTMLFormElement>,
  { email, password }: Credentials,
  setErrorMessage: SetErrorMessage
) {
  event.preventDefault();
  try {
    const response = await firebaseApp.auth().signInWithEmailAndPassword(email, password);
    const user = response.user;
    if (!user) return setErrorMessage('Unable to log in: unknown error');
  } catch (error) {
    setErrorMessage(error.message);
  }
}

async function signUp({ email, password }: Credentials, setErrorMessage: SetErrorMessage) {
  try {
    const response = await firebaseApp.auth().createUserWithEmailAndPassword(email, password);
    const user = response.user;
    if (!user) return setErrorMessage('Unable to sign up: unknown error');
  } catch (error) {
    setErrorMessage(error.message);
  }
}
async function forgotPassword({ email }: Credentials, setErrorMessage: SetErrorMessage) {
  try {
    await firebaseApp.auth().sendPasswordResetEmail(email);
    setErrorMessage('Email for password reset sent, please check your mails');
  } catch (error) {
    setErrorMessage(error.message);
  }
}

type SetErrorMessage = React.Dispatch<React.SetStateAction<string>>;

interface Credentials {
  email: string;
  password: string;
}
